import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=5e2b0618&scoped=true&lang=pug&"
import script from "./Form.vue?vue&type=script&setup=true&lang=js&"
export * from "./Form.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=5e2b0618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b0618",
  null
  
)

export default component.exports